import HeartIcon from "~icons/ph/heart-light"
import SmileIcon from "~icons/ph/smiley"
import HandsPrayingIcon from "~icons/ph/hands-praying"
import EarthIcon from "~icons/ph/globe-hemisphere-west"
import RedCrossIcon from "~icons/fluent/doctor-16-regular"
import DogIcon from "~icons/ph/dog"
import WaterIcon from "~icons/ph/drop"
import HandWithHeartIcon from "~icons/ph/hand-heart"

export const DONATION_THANK_YOU_ICONS = {
  heart: {
    icon: HeartIcon,
    label: "Heart",
  },
  smile: {
    icon: SmileIcon,
    label: "Smile",
  },
  "hands-praying": {
    icon: HandsPrayingIcon,
    label: "Hands Praying",
  },
  earth: {
    icon: EarthIcon,
    label: "Earth",
  },
  "red-cross": {
    icon: RedCrossIcon,
    label: "Red Cross",
  },
  dog: {
    icon: DogIcon,
    label: "Dog",
  },
  water: {
    icon: WaterIcon,
    label: "Water",
  },
  "hand-with-heart": {
    icon: HandWithHeartIcon,
    label: "Hand With Heart",
  },
} as const

export const donationThankyouIcons = Object.keys(
  DONATION_THANK_YOU_ICONS
) as Array<DonationThankYouIcon>

export type DonationThankYouIcon =
  keyof typeof DONATION_THANK_YOU_ICONS

export type DonationSettings = {
  button1Amount: number
  button2Amount: number
  button3Amount: number
  button4Amount: number
  button5Amount: number
  button6Amount: number
  thankYouMessage: string
  thankYouIcon: DonationThankYouIcon
}
